import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Spinner } from 'reactstrap';
import PropTypes from 'prop-types';

const SaveSubmitButton = ({
  messageId,
  messageValues,
  isSubmitting,
  className,
  disabled,
  ...props
}) => {
  return (
    <Button
      color="primary"
      type="submit"
      className={`btn-block ${className}`}
      disabled={disabled || isSubmitting}
      {...props}
    >
      {isSubmitting ? (
        <>
          <Spinner color="white" size="sm" />
          <span className="ml-50">
            <FormattedMessage id="loading" />
          </span>
        </>
      ) : (
        <FormattedMessage id={messageId || 'save'} values={messageValues} />
      )}
    </Button>
  );
};

SaveSubmitButton.propTypes = {
  messageId: PropTypes.string,
  isSubmitting: PropTypes.bool,
};

export default SaveSubmitButton;
